import { VisibilityOutlined, VisibilityOffOutlined } from "@material-ui/icons";
import { Formik } from "formik";
import React, { Component } from "react";
import { connect } from "react-redux";
import LoginBox from "../../components/login/LoginBox";
import InputCustom from "../../components/InputCustom";
import Button from "../../components/Button";
import { primeiroAcesso } from "../../crud/auth.crud";
import * as auth from "../../store/ducks/auth.duck";
import { validateFormRegisterStep2 } from "./RegisterUtils";
import styles from "../../styles/ForgotPassword.module.scss";
import Swal from "sweetalert2";

const initial_values = { senha: "", senhaConfirm: "" };

class PrimeiroAcesso extends Component {
  state = {
    loading: false,
    mostrarSenha: false,
    mostrarSenhaConfirm: false,
    verificacao: {
      oitoCarac: false,
      letraMaiuscula: false,
      letraMinuscula: false,
      numero: false,
      caractereEspecial: false,
    },
  };

  handleShow = (marcador) => {
    this.setState((prevState) => ({
      [marcador]: !prevState[marcador],
    }));
  };

  verificarSenha = (senha) => {
    this.setState({
      verificacao: {
        oitoCarac: senha.length >= 8,
        letraMaiuscula: /[A-Z]/.test(senha),
        letraMinuscula: /[a-z]/.test(senha),
        numero: /\d/.test(senha),
        caractereEspecial: /[!@#$%&/+\-=[\]{}()*_.,;:<>?]/.test(senha),
      },
    });
  };

  handleCriarSenha = (values, setErrors) => {
    const err = validateFormRegisterStep2(values);
    
    if (Object.keys(err).length > 0) {
      setErrors(err);
      const first = Object.values(err)[0];
      Swal.fire("Ops!", first, "warning");
      
      return;
    }
    
    this.setState({ loading: true });
    const data = { password: values.senha, password_confirmation: values.senhaConfirm };
    
    primeiroAcesso(data)
      .then((response) => {
        this.props.fulfillUser(response.data.user);
        
        return Swal.fire("Sucesso!", "Senha criada. Bem-vindo(a)!", "success");
      })
      .then(() => {
        this.props.history.push("/inicio");
      })
      .catch((err) => {
        const msg = err.response?.data?.errors?.[0] || "Erro ao criar senha. Tente novamente.";
        
        Swal.fire("Ops!", msg, "error");
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { loading, mostrarSenha, mostrarSenhaConfirm, verificacao } = this.state;

    return (
      <div className="login-inner flex-column">
        <Formik initialValues={initial_values} onSubmit={() => {}}>
          {({ values, setFieldValue, setErrors, handleChange, handleBlur, touched, errors }) => (
            <LoginBox
              loading={loading}
              titulo={"Primeiro acesso"}
              subtitulo={"Identificamos que esse é seu primeiro acesso. Crie uma senha para acessar sua conta."}
              voltar={"/logout"}
              size={"small"}
              customClass={"senha"}
            >
              <div className="flex-column" style={{ gap: "24px" }}>
                <InputCustom
                  label={"Nova senha"}
                  name={"senha"}
                  type={mostrarSenha ? "text" : "password"}
                  value={values.senha}
                  onChange={(e) => {
                    const valor = e.target.value;
                    setFieldValue("senha", valor);
                    this.verificarSenha(valor);
                  }}
                  onBlur={handleBlur}
                  disabled={loading}
                  required
                  errors={errors}
                  touched={touched}
                  icon_left={mostrarSenha ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
                  icon_style={{ cursor: "pointer" }}
                  onIconClick={() => this.handleShow("mostrarSenha")}
                />

                <InputCustom
                  label={"Confirme sua nova senha"}
                  name={"senhaConfirm"}
                  type={mostrarSenhaConfirm ? "text" : "password"}
                  value={values.senhaConfirm}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled={loading}
                  required
                  errors={errors}
                  touched={touched}
                  icon_left={mostrarSenhaConfirm ? <VisibilityOutlined /> : <VisibilityOffOutlined />}
                  icon_style={{ cursor: "pointer" }}
                  onIconClick={() => this.handleShow("mostrarSenhaConfirm")}
                />
              </div>

              <div className={`deve-conter ${styles.requirements}`}>
                <p className={styles.title}>Sua senha deve conter:</p>
                
                <div className={`${styles.row} ${verificacao.oitoCarac ? styles.met : ""}`}>
                  <i className={`far fa-check-circle ${styles.icon}`} aria-hidden />
                  <span>No mínimo 8 caracteres</span>
                </div>
                
                <div className={`${styles.row} ${verificacao.letraMinuscula ? styles.met : ""}`}>
                  <i className={`far fa-check-circle ${styles.icon}`} aria-hidden />
                  <span>Ao menos 1 letra minúscula</span>
                </div>
                
                <div className={`${styles.row} ${verificacao.letraMaiuscula ? styles.met : ""}`}>
                  <i className={`far fa-check-circle ${styles.icon}`} aria-hidden />
                  <span>Ao menos 1 letra maiúscula</span>
                </div>
                
                <div className={`${styles.row} ${verificacao.numero ? styles.met : ""}`}>
                  <i className={`far fa-check-circle ${styles.icon}`} aria-hidden />
                  <span>Ao menos 1 número (0123456789)</span>
                </div>
                
                <div className={`${styles.row} ${verificacao.caractereEspecial ? styles.met : ""}`}>
                  <i className={`far fa-check-circle ${styles.icon}`} aria-hidden />
                  <span>Ao menos 1 caractere especial (*!@#$%&/+-=)</span>
                </div>
              </div>

              <Button
                type="button"
                disabled={loading}
                variant="primary"
                size="lg"
                height="lg"
                fullWidth={true}
                loading={loading}
                children="Criar senha"
                onClick={() => this.handleCriarSenha(values, setErrors)}
              />
            </LoginBox>
          )}
        </Formik>
      </div>
    );
  }
}

export default connect(null, auth.actions)(PrimeiroAcesso);
